import {of} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import OrganizationPerson from 'web-app/react/entities/organization-persons/model';
import * as OrganizationPersonsActions from 'web-app/react/entities/organization-persons/actions';

import * as Actions from './actions';

const submit = action$ =>
    action$.ofType(Actions.submit.type).mergeMap(({payload}) => {
        const oldPerson = {
            organizationId: payload.organizationId,
            organizationPersonId: payload.organizationPersonId,
        };
        const newPerson = OrganizationPerson.fromFormData(payload);
        return of(OrganizationPersonsActions.update.action(oldPerson, newPerson));
    });

const submitSuccess = action$ =>
    action$.ofType(OrganizationPersonsActions.updateSuccess.type).mergeMap(() => {
        return of(Actions.submitSuccess.action());
    });

const submitFailed = action$ =>
    action$.ofType(OrganizationPersonsActions.updateFailed.type).mergeMap(() => {
        return of(Actions.submitFailed.action());
    });

export default combineEpics(submit, submitSuccess, submitFailed);
